var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown",class:{ inline: _vm.inline },domProps:{"innerHTML":_vm._s(_vm.htmlContent)},on:{"click":_vm.onLinkClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }